import { render, staticRenderFns } from "./topMenu.vue?vue&type=template&id=020edb09&scoped=true&"
import script from "./topMenu.vue?vue&type=script&lang=js&"
export * from "./topMenu.vue?vue&type=script&lang=js&"
import style0 from "./topMenu.vue?vue&type=style&index=0&id=020edb09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020edb09",
  null
  
)

export default component.exports